/**
 * AddCardDialog - Dialog to add credit card via Payrexx
 * Extracted from CustomersPage.js
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const AddCardDialog = ({
  open,
  onOpenChange,
  cardPaymentLink,
  onVerifyPaymentToken
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Kreditkarte hinterlegen (Payrexx)</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-blue-900 mb-2">So funktioniert es:</h4>
            <ol className="list-decimal list-inside space-y-2 text-sm text-blue-800">
              <li>Öffnen Sie den Payment-Link in einem neuen Tab</li>
              <li>Geben Sie Ihre Kreditkartendaten ein</li>
              <li>Die Karte wird mit 0.01 CHF autorisiert (nicht abgebucht)</li>
              <li>Kehren Sie hierher zurück und klicken Sie auf &quot;Verifizieren&quot;</li>
            </ol>
          </div>
          
          {cardPaymentLink && (
            <div className="space-y-3">
              <div className="p-4 bg-white border rounded-lg">
                <p className="text-sm text-gray-600 mb-3">Payment-Link:</p>
                <div className="flex gap-2">
                  <Input 
                    value={cardPaymentLink} 
                    readOnly 
                    className="font-mono text-sm"
                  />
                  <Button
                    onClick={() => {
                      navigator.clipboard.writeText(cardPaymentLink);
                      toast.success('Link kopiert!');
                    }}
                    variant="outline"
                    size="sm"
                  >
                    📋 Kopieren
                  </Button>
                </div>
              </div>
              
              <div className="flex gap-2">
                <Button
                  onClick={() => window.open(cardPaymentLink, '_blank')}
                  className="flex-1"
                >
                  🔗 Payment-Link öffnen
                </Button>
                <Button
                  onClick={onVerifyPaymentToken}
                  variant="outline"
                  className="flex-1"
                >
                  ✅ Verifizieren
                </Button>
              </div>
              
              <p className="text-xs text-gray-500 text-center">
                Nach dem Hinterlegen der Kreditkarte klicken Sie auf &quot;Verifizieren&quot;
              </p>
            </div>
          )}
          
          <div className="bg-gray-50 border rounded-lg p-3 text-xs text-gray-600">
            <p className="font-semibold mb-1">🔒 Sicherheit:</p>
            <p>Ihre Kreditkartendaten werden sicher bei Payrexx (PCI-DSS Level 1) gespeichert. Wir speichern nur die letzten 4 Ziffern und das Ablaufdatum.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddCardDialog;
